import React, { lazy } from 'react';
import { Check, ShieldCheck } from 'lucide-react';
import { PriceDisplay } from './PriceDisplay';
import { CountdownTimer } from './CountdownTimer';
import { PremiumPriceCard } from './PremiumPriceCard';
import { usePricingContext } from '../context/PricingContext';
export function PricingOffer() {
  const {
    cartLink,
    fireAddToCart
  } = usePricingContext();
  return <section className="py-12 md:py-16 relative" id="offer" style={{
    background: '#FBF8F2'
  }} data-id="element-137">
      <div className="gold-divider absolute top-0 inset-x-0" data-id="element-138" />
      <div className="container mx-auto px-4 max-w-4xl relative z-10" data-id="element-139">
        <div className="rounded-3xl overflow-hidden" style={{
        border: '2px solid rgba(200,169,106,0.4)',
        boxShadow: '0 8px 40px rgba(60,40,10,0.10)'
      }} data-id="element-140">
          <div className="p-5 text-center" style={{
          background: '#EFE7D8',
          borderBottom: '1px solid rgba(200,169,106,0.3)'
        }} data-id="element-141">
            <img src="https://cdn.magicpatterns.com/uploads/oCbvWWAFuYDUrbNpqykJaQ/Capa-Cartas-de-Paulo.webp" alt="Las Cartas de Pablo — Colección Completa" className="w-full h-auto block rounded-xl" width={800} height={1067} loading="lazy" decoding="async" data-id="element-142" />
          </div>

          <div className="p-5 md:p-8" style={{
          background: '#FBF8F2'
        }} data-id="element-143">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-7" data-id="element-144">
              {/* Left: features list */}
              <div data-id="element-145">
                <h3 className="text-base font-bold mb-4 pb-2" style={{
                color: '#B89555',
                borderBottom: '1px solid rgba(200,169,106,0.25)'
              }} data-id="element-146">
                  Todo Lo Que Recibes Hoy:
                </h3>
                <ul className="space-y-3" data-id="element-147">
                  <li className="flex items-start" data-id="element-148">
                    <Check className="w-3.5 h-3.5 mr-2 flex-shrink-0 mt-0.5" style={{
                    color: '#1A6B3A'
                  }} data-id="element-149" />
                    <span className="text-xs" style={{
                    color: '#2C2C2C'
                  }} data-id="element-150">
                      <strong style={{
                      color: '#161616'
                    }} data-id="element-151">
                        13 Epístolas Paulinas
                      </strong>{' '}
                      explicadas versículo por versículo (Valor $33.00)
                    </span>
                  </li>
                  {['Comunicación Eficaz en el Púlpito ($14.00)', 'Desarrollo Espiritual del Predicador ($14.00)', 'Exégesis y Hermenéutica Bíblica ($14.00)', 'Historia de la Predicación Cristiana ($14.00)', 'Predicación Expositiva ($14.00)', 'Predicación Temática ($14.00)', 'Preparación de Sermones — Guía Completa ($15.00)'].map((item, i) => <li key={i} className="flex items-start" data-id="element-152">
                      <Check className="w-3.5 h-3.5 mr-2 flex-shrink-0 mt-0.5" style={{
                    color: '#1A6B3A'
                  }} data-id="element-153" />
                      <span className="text-xs" style={{
                    color: '#505050'
                  }} data-id="element-154">
                        Bono #{i + 1}: {item}
                      </span>
                    </li>)}
                </ul>
                <div className="mt-5 pt-4" style={{
                borderTop: '1px solid rgba(200,169,106,0.2)'
              }} data-id="element-155">
                  <div className="flex justify-between items-center mb-1.5" data-id="element-156">
                    <span className="font-bold text-xs" style={{
                    color: '#505050'
                  }} data-id="element-157">
                      Valor Total Real:
                    </span>
                    <span className="font-bold text-sm" style={{
                    color: '#8A8A8A',
                    textDecoration: 'line-through'
                  }} data-id="element-158">
                      <PriceDisplay type="compare" data-id="element-159" />
                    </span>
                  </div>
                  <div className="flex justify-between items-center" data-id="element-160">
                    <span className="font-bold text-sm" style={{
                    color: '#2C2C2C'
                  }} data-id="element-161">
                      Precio Regular:
                    </span>
                    <span className="font-bold text-sm" style={{
                    color: '#8A8A8A',
                    textDecoration: 'line-through'
                  }} data-id="element-162">
                      <PriceDisplay type="compare" data-id="element-163" />
                    </span>
                  </div>
                </div>
              </div>

              {/* Right: Premium Price Card */}
              <PremiumPriceCard ctaLabel="AGREGAR AL CARRITO »" data-id="element-164" />
            </div>
          </div>
        </div>

        {/* Guarantee */}
        <div className="mt-8 p-6 rounded-2xl flex flex-col md:flex-row items-center gap-5" style={{
        background: '#F6F1E7',
        border: '1px solid rgba(200,169,106,0.25)'
      }} data-id="element-165">
          <div className="flex-shrink-0" data-id="element-166">
            <ShieldCheck className="w-14 h-14" style={{
            color: '#C8A96A'
          }} data-id="element-167" />
          </div>
          <div className="text-center md:text-left" data-id="element-168">
            <h3 className="text-xl font-serif font-bold mb-2" style={{
            color: '#161616'
          }} data-id="element-169">
              Garantía "Ámalo o Déjalo" — 100% Sin Riesgo
            </h3>
            <p className="text-sm leading-relaxed mb-2" style={{
            color: '#2C2C2C'
          }} data-id="element-170">
              Pruébalo con total tranquilidad. Si este no es el recurso bíblico
              más completo que hayas visto, escríbenos y te devolvemos el 100%
              de tu dinero. Sin preguntas. Sin letra pequeña.
            </p>
            <p className="font-serif italic font-bold text-sm" style={{
            color: '#B89555'
          }} data-id="element-171">
              — Equipo Instituto Saber de Cristo
            </p>
          </div>
        </div>
      </div>
      <div className="gold-divider absolute bottom-0 inset-x-0" data-id="element-172" />
    </section>;
}